
class OySwipers {
    constructor() {
		  this.swipers = [];

		  try {
      	  	this.initSwipers();
		  } catch (e) {
			  console.log(e.message);
		  }
	  }

    initSwipers() {

    let swiperElement = jQuery( '.swiper' );

		if( null !== swiperElement && ! swiperElement.hasClass( 'swiper-container-initialized' ) ) {
      var swiper = new Swiper('.swiper', {
				direction: 'horizontal',
				slidesPerView: 1,
				spaceBetween: 0,
        loop: true,
				navigation: {
					nextEl: '.swiper-button-next',
					prevEl: '.swiper-button-prev',
			  },
				// Responsive breakpoints
				breakpoints: {
					// when window width is >= 640px
					640: {
						slidesPerView: 2
					},
					1024: {
						slidesPerView: 4
					},
				}
			});
		}
  }
}

export {OySwipers}
